import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Mostrar el modal automáticamente al cargar la página
    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modalElement = this.element
      const modal = new bootstrap.Modal(modalElement, {
        backdrop: true,
        keyboard: true
      })
      modal.show()
    } else if (typeof jQuery !== 'undefined' && jQuery.fn.modal) {
      // Fallback para jQuery Bootstrap
      jQuery(this.element).modal('show')
    }
  }
}
